import { mutate } from 'swr';
import api from '../../services/api';

// Folder mutations
export const createFolder = async (clientId: number, data: {
  templateId: number;
  displayOrder?: number;
}) => {
  const response = await api.post(`/client-vault/${clientId}/folders`, data);
  await mutate(`/client-vault/${clientId}/folders`);
  await mutate(`/client-vault/${clientId}/vault`);
  return response.data;
};

export const updateFolder = async (clientId: number, folderId: number, data: {
  displayOrder?: number;
}) => {
  const response = await api.patch(`/client-vault/${clientId}/folders/${folderId}`, data);
  await mutate(`/client-vault/${clientId}/folders`);
  await mutate(`/client-vault/${clientId}/folders/${folderId}`);
  await mutate(`/client-vault/${clientId}/vault`);
  return response.data;
};

export const deleteFolder = async (clientId: number, folderId: number) => {
  await api.delete(`/client-vault/${clientId}/folders/${folderId}`);
  await mutate(`/client-vault/${clientId}/folders`);
  await mutate(`/client-vault/${clientId}/vault`);
};

export const reorderFolders = async (clientId: number, folderOrders: { folderId: number; displayOrder: number }[]) => {
  await api.patch(`/client-vault/${clientId}/folders/reorder`, folderOrders);
  await mutate(`/client-vault/${clientId}/folders`);
  await mutate(`/client-vault/${clientId}/vault`);
};

// Record mutations
export const createRecord = async (clientId: number, folderId: number, data: {
  title: string;
  recordType: string;
  data: any;
  encryptedData?: string;
  tags?: string[];
  isPrivate?: boolean;
}) => {
  const response = await api.post(`/client-vault/${clientId}/folders/${folderId}/records`, data);
  await mutate(`/client-vault/${clientId}/folders/${folderId}/records`);
  await mutate(`/client-vault/${clientId}/vault`);
  return response.data;
};

export const updateRecord = async (clientId: number, folderId: number, recordId: number, data: {
  title?: string;
  recordType?: string;
  data?: any;
  encryptedData?: string;
  tags?: string[];
  isPrivate?: boolean;
}) => {
  const response = await api.patch(`/client-vault/${clientId}/records/${recordId}?folderId=${folderId}`, data);
  await mutate(`/client-vault/${clientId}/folders/${folderId}/records`);
  await mutate(`/client-vault/${clientId}/vault`);
  return response.data;
};

export const deleteRecord = async (clientId: number, folderId: number, recordId: number) => {
  await api.delete(`/client-vault/${clientId}/records/${recordId}?folderId=${folderId}`);
  await mutate(`/client-vault/${clientId}/folders/${folderId}/records`);
  await mutate(`/client-vault/${clientId}/vault`);
};

// File mutations
export const uploadFile = async (clientId: number, folderId: number, file: File, data?: {
  description?: string;
  isPrivate?: boolean;
}) => {
  const formData = new FormData();
  formData.append('file', file);
  if (data?.description) {
    formData.append('description', data.description);
  }
  if (data?.isPrivate !== undefined) {
    formData.append('isPrivate', String(data.isPrivate));
  }

  const response = await api.post(`/client-vault/${clientId}/folders/${folderId}/files`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  await mutate(`/client-vault/${clientId}/folders/${folderId}/files`);
  await mutate(`/client-vault/${clientId}/vault`);
  return response.data;
};

export const deleteFile = async (clientId: number, folderId: number, fileId: number) => {
  await api.delete(`/client-vault/${clientId}/files/${fileId}?folderId=${folderId}`);
  await mutate(`/client-vault/${clientId}/folders/${folderId}/files`);
  await mutate(`/client-vault/${clientId}/vault`);
};

// Template mutations
export const createTemplate = async (data: {
  name: string;
  description?: string;
  color?: string;
  icon?: string;
  displayOrder?: number;
  isActive?: boolean;
}) => {
  const response = await api.post(`/client-vault/templates`, data);
  await mutate(`/client-vault/templates`);
  await mutate(`/client-vault/templates?includeInactive=true`);
  return response.data;
};

export const updateTemplate = async (templateId: number, data: {
  name?: string;
  description?: string;
  color?: string;
  icon?: string;
  displayOrder?: number;
  isActive?: boolean;
}) => {
  const response = await api.patch(`/client-vault/templates/${templateId}`, data);
  await mutate(`/client-vault/templates`);
  await mutate(`/client-vault/templates?includeInactive=true`);
  await mutate(`/client-vault/templates/${templateId}`);
  return response.data;
};

export const deleteTemplate = async (templateId: number) => {
  await api.delete(`/client-vault/templates/${templateId}`);
  await mutate(`/client-vault/templates`);
  await mutate(`/client-vault/templates?includeInactive=true`);
};

